"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PeopleGroupIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
}, props));
PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var _default = exports.default = PeopleGroupIcon;